var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-simple-suggest",
    {
      attrs: {
        "value-attribute": "option_value",
        "display-attribute": "postal",
        list: _vm.searchForPostalCodes,
        "max-suggestions": 8,
        styles: _vm.autoCompleteStyle,
        destyled: true,
        debounce: 100,
        mode: "select"
      },
      on: { select: _vm.itemSelected, blur: _vm.onBlur, focus: _vm.onFocus },
      model: {
        value: _vm.selectedItem,
        callback: function($$v) {
          _vm.selectedItem = $$v
        },
        expression: "selectedItem"
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query"
          }
        ],
        staticClass: "form-control",
        attrs: {
          "aria-label": "Postinumero",
          type: "text",
          maxlength: "20",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.query },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }